module.exports = __webpack_public_path__ + "img/unavailable-icon.9019fa7b.svg";